import { FC, useMemo, useState, useCallback } from 'react'
import moment from 'moment'
import styles from 'components/features/future/FutureWhenInput/FutureWhenInput.styl'
import { monthsLeftInYear } from 'helpers/dateTimeHelpers'
import { Select } from 'components/atoms/inputs/Select/Select'

const MONTH_OPTIONS = [
  {
    label: 'January',
    value: '1',
  },
  {
    label: 'February',
    value: '2',
  },
  {
    label: 'March',
    value: '3',
  },
  {
    label: 'April',
    value: '4',
  },
  {
    label: 'May',
    value: '5',
  },
  {
    label: 'June',
    value: '6',
  },
  {
    label: 'July',
    value: '7',
  },
  {
    label: 'August',
    value: '8',
  },
  {
    label: 'September',
    value: '9',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
]

const remainingMonths = MONTH_OPTIONS.slice(Math.max(MONTH_OPTIONS.length - monthsLeftInYear(), 1))
const currentYear = new Date().getFullYear()
const years = new Array(80)
  .fill(0)
  .map((_: undefined, index: number) => {
    const year = `${ currentYear + index }`
    return {
      label: year,
      value: year,
    }
  })

type YearMonthInputProps = {
  initialValue: string
  onChange: (date: string) => void
}
export const YearMonthInput: FC<YearMonthInputProps> = (props) => {
  const { initialValue, onChange } = props

  const initialDate = useMemo(() => {
    const date = moment(initialValue)
    return {
      month: date.format('M'),
      year: date.format('YYYY'),
    }
  }, [initialValue])

  const today = new Date()
  const [currentDate, setCurrentDate] = useState(initialDate)
  const currentYearSelected = parseInt(currentDate.year, 10) === today.getFullYear()
  const options = currentYearSelected ? remainingMonths : MONTH_OPTIONS

  const handleChange = useCallback<(date: typeof initialDate) => void>((date) => {
    onChange(`${ date.year }-${ date.month.padStart(2, '0') }`)
  }, [onChange])

  const handleMonthChange = useCallback<(value: string | null) => void>((month) => {
    if (month === null) {
      return
    }

    const nextDate = {
      ...currentDate,
      month,
    }

    handleChange(nextDate)
    setCurrentDate(nextDate)
  }, [currentDate, handleChange])

  const handleYearChange = useCallback<(value: string | null) => void>((value) => {
    if (value === null) {
      return
    }

    const isCurrentYear = moment().year() === parseInt(value, 10)
    const nextMonthInCurrentYear = (parseInt(moment().format('M'), 10) + 1).toString()

    const nextDate = {
      month: isCurrentYear ? nextMonthInCurrentYear : currentDate.month,
      year: value,
    }

    handleChange(nextDate)
    setCurrentDate(nextDate)
  }, [currentDate.month, handleChange])

  return (
    <div className={ styles.twoCols }>
      <div className={ styles.col }>
        <Select<string> options={ options } value={ currentDate.month } onChange={ handleMonthChange } />
      </div>
      <div className={ styles.col }>
        <Select<string> options={ years } value={ currentDate.year } onChange={ handleYearChange } />
      </div>
    </div>
  )
}
